import devToggles from './features/dev';
import stageToggles from './features/stage';
import prodToggles from './features/prod';

 
export const featureFlags = (env) => {
    const featureFileMap = {
        DEV: devToggles,
        STAGE: stageToggles,
        PROD: prodToggles
    };

    const getEnvironment = () => {
        const ENVIRONMENT = typeof env === 'string' ? env.toUpperCase() : 'LOCAL';
        switch (ENVIRONMENT){
          case 'LOCAL':
          case 'LOCALHOST':
          case 'SANDBOX':
          case 'DEV':
            return 'DEV';
          case 'STAGE':
            return 'STAGE';
          case 'PROD':
          case 'PRODUCTION':
            return 'PROD';
          default:
            return 'DEV';
        }
      };

    const featuresFile = featureFileMap[getEnvironment()];


   return featuresFile.reduce((flags, feature) =>
      Object.assign(flags, {[feature.name]: feature.value}), {});
}

export default featureFlags;
